export { A as Accordion } from './Accordion-8b29ba5d.js';
export { default as AmenitiesList } from './AmenitiesList.js';
export { B as Button } from './Button-9db40655.js';
export { C as Card } from './Card-683c5834.js';
export { default as Carrousel } from './Carrousel.js';
export { default as Checkbox } from './Checkbox.js';
export { default as CheckboxGroup } from './CheckboxGroup.js';
export { default as Container } from './Container.js';
export { default as Description } from './Description.js';
export { default as DescriptionList } from './DescriptionList.js';
export { default as Divider } from './Divider.js';
export { default as FeedbackMessage } from './FeedbackMessage.js';
export { default as Icon } from './Icon.js';
export { default as Image } from './Image.js';
export { default as Input } from './Input.js';
export { default as Label } from './Label.js';
export { default as LazyImage } from './LazyImage.js';
export { default as LoadingSpinner, default as Location } from './LoadingSpinner.js';
export { default as MapView } from './MapView.js';
export { default as Modal } from './Modal.js';
export { default as NewTabLink } from './NewTabLink.js';
export { N as NumberPicker } from './index-a847c18e.js';
export { default as OccupancySelectorContent } from './OccupancySelectorContent.js';
export { default as PhotoGallery } from './PhotoGallery.js';
export { P as PropertyCard } from './index-16974fec.js';
export { default as PropertiesList } from './PropertiesList.js';
export { default as PropertiesLayout } from './PropertiesLayout.js';
export { default as Radio } from './Radio.js';
export { default as RoomDetailsModal } from './RoomDetailsModal.js';
export { default as Select } from './Select.js';
export { default as SearchInput } from './SearchInput.js';
export { default as SimpleMapView } from './SimpleMapView.js';
export { default as Switch } from './Switch.js';
export { default as Tabs } from './Tabs.js';
export { default as Textarea } from './Textarea.js';
export { default as Title } from './Title.js';
export { default as Toast } from './Toast.js';
export { P as PortalFilters } from './index-f4bc64e2.js';
export { default as PaymentOptionGroups } from './PaymentOptionGroups.js';
export { default as PaymentAdviceRow } from './PaymentAdviceRow.js';
export { default as PanelTitle } from './PanelTitle.js';
export { default as Slider } from './Slider.js';
export { i as QueryParametersService } from './index-2b56af5d.js';
export { D as DayPickerRangeControllerWrapper, g as getRegionalLocale } from './DayPickerRangeControllerWrapper-c5e42de8.js';
export { D as DateRangeSelectorInputs } from './DateRangeSelectorInputs-4696d43c.js';
import { _ as _slicedToArray, a as _createClass, b as _classCallCheck, c as _asyncToGenerator, d as _regeneratorRuntime, e as _objectSpread2, f as _objectWithoutProperties, g as _toConsumableArray, h as _extends, i as _toArray } from './_rollupPluginBabelHelpers-f5c57928.js';
import moment from 'moment';
import PropTypes from 'prop-types';
import React__default, { useState, useRef, useMemo, useCallback, useEffect } from 'react';
import { s as src } from './PropTypes-9aad034b.js';
import { u as useWindowSize } from './useWindowSize-51f81a2a.js';
export { S as SUPPORTED_REGION_LOCALES } from './general-2a8d8650.js';
import './utilsHelpers-21a239d9.js';
import './useComponentWidth-f74aea3c.js';
import './_commonjsHelpers-97e6d7b1.js';
import './index-c093c499.js';
import 'react-dom';
import './ModalHeader-daaa2bf6.js';
import './tslib.es6-2748fcb6.js';
import './handleOpenLink-49ba3691.js';
import './hoist-non-react-statics.cjs-596f6afc.js';
import 'react-slick';
import './useIntl-2030d1c8.js';
import './injectIntl-0da7053c.js';
import './Location.js';
import './Price.js';
import './index-c101e2b0.js';
import './provider-b3aa55fe.js';
import './LoadingBlock.js';
import './PropertyRating.js';
import './usePrevious-edd83563.js';
import './EmptySectionMessage.js';
import './Popup.js';
import './MapLayoutGoogle.js';
import './Paginator.js';
import './DropdownMenu.js';
import './useKeyPress-2cc374e7.js';
import './PropertiesFilterByName.js';
import 'rc-slider';
import 'rc-slider/lib/Slider';
import 'moment/locale/de';
import 'moment/locale/it';
import 'moment/locale/fr';
import 'moment/locale/zh-cn';
import 'moment/locale/pt';
import 'moment/locale/es';
import 'moment/locale/th';
import 'moment/locale/sq';
import 'moment/locale/ar';
import 'moment/locale/be';
import 'moment/locale/bg';
import 'moment/locale/ca';
import 'moment/locale/hr';
import 'moment/locale/cs';
import 'moment/locale/da';
import 'moment/locale/nl';
import 'moment/locale/eo';
import 'moment/locale/et';
import 'moment/locale/fi';
import 'moment/locale/el';
import 'moment/locale/he';
import 'moment/locale/hi';
import 'moment/locale/hu';
import 'moment/locale/is';
import 'moment/locale/id';
import 'moment/locale/ga';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/lv';
import 'moment/locale/lt';
import 'moment/locale/mk';
import 'moment/locale/ms';
import 'moment/locale/mt';
import 'moment/locale/nb';
import 'moment/locale/pl';
import 'moment/locale/ro';
import 'moment/locale/ru';
import 'moment/locale/sr';
import 'moment/locale/sk';
import 'moment/locale/tr';
import 'moment/locale/uk';
import 'moment/locale/vi';
import 'moment/locale/en-gb';
import 'moment/locale/en-ca';
import 'react-dates/initialize';
import 'react-dates';
import './SearchBarItem.js';

var calculateNumOfDays = function calculateNumOfDays(date1, date2) {
  return Math.floor((date1 - date2) / 24 / 60 / 60 / 1000);
};
var parseIsoDateString = function parseIsoDateString(isoDate) {
  if (typeof isoDate === 'string') {
    var _isoDate$split = isoDate.split('-'),
      _isoDate$split2 = _slicedToArray(_isoDate$split, 3),
      yearPart = _isoDate$split2[0],
      monthPart = _isoDate$split2[1],
      dayPart = _isoDate$split2[2];
    var year = parseInt(yearPart, 10);
    var month = parseInt(monthPart, 10) - 1;
    var day = parseInt(dayPart, 10);
    var date = new Date(year, month, day, 0, 0, 0);
    return date;
  }
  if (isoDate instanceof Date) {
    return isoDate;
  }

  // best effort try -> this may return wrong results depending on the locale.
  // https://stackoverflow.com/questions/2587345/why-does-date-parse-give-incorrect-results
  return new Date(Date.parse(isoDate));
};
var toPaddedToken = function toPaddedToken(num) {
  return num > 9 ? "".concat(num) : "0".concat(num);
};
var formatToIsoDateString = function formatToIsoDateString(date) {
  var year = date.getFullYear();
  var month = toPaddedToken(date.getMonth() + 1);
  var day = toPaddedToken(date.getDate());
  return "".concat(year, "-").concat(month, "-").concat(day);
};
var getDateOfLastDayInMonth = function getDateOfLastDayInMonth(date) {
  var lastDayInMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return lastDayInMonth;
};
var getLastDateParameterForCalendar = function getLastDateParameterForCalendar(startDate) {
  return formatToIsoDateString(getDateOfLastDayInMonth(parseIsoDateString(startDate)));
};
var groupDatesInRanges = function groupDatesInRanges(dates) {
  if (dates.length === 0) {
    return [];
  }
  var ranges = [];
  var start = null;
  dates.forEach(function (date, index) {
    if (index === 0) {
      start = date;
    } else {
      var prevDate = dates[index - 1];
      if (calculateNumOfDays(date, prevDate) > 1) {
        ranges.push({
          from: start,
          to: prevDate
        });
        start = date;
      }
    }
  });
  ranges.push({
    from: start,
    to: dates[dates.length - 1]
  });
  return ranges;
};
var isDebugOutputEnabled = function isDebugOutputEnabled() {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.location.search.indexOf('skd-verbose-debug') !== -1;
};
var log = function () {
  var isInitialized = false;
  var logToConsole = function logToConsole() {};
  return function () {
    if (!isInitialized) {
      isInitialized = true;
      if (isDebugOutputEnabled()) {
        logToConsole = console.log.bind(console);
      }
    }
    logToConsole.apply(void 0, arguments);
  };
}();

var CALENDAR_MONTH_STATUS = {
  PLACEHOLDER: 'PLACEHOLDER',
  FALLBACK: 'FALLBACK',
  PRESENT: 'PRESENT'
};

var getStackableRequestId = function () {
  var idCounter = 0;
  return function () {
    idCounter++;
    return "stackable-request-".concat(idCounter);
  };
}();
var StackableRequest = /*#__PURE__*/function () {
  function StackableRequest(_ref) {
    var month = _ref.month,
      fetch = _ref.fetch,
      onFetched = _ref.onFetched,
      fetchFallback = _ref.fetchFallback,
      _ref$timeUntilFallbac = _ref.timeUntilFallback,
      timeUntilFallback = _ref$timeUntilFallbac === void 0 ? 2000 : _ref$timeUntilFallbac;
    _classCallCheck(this, StackableRequest);
    this.fetch = fetch;
    this.fetchFallback = fetchFallback;
    this.timeUntilFallback = timeUntilFallback;
    this.month = month;
    this.onFetched = onFetched;
    this.isExecuting = false;
    this.id = getStackableRequestId();
  }
  return _createClass(StackableRequest, [{
    key: "getRequestedMonths",
    value: function getRequestedMonths() {
      var _this$fetch$meta;
      if (typeof ((_this$fetch$meta = this.fetch.meta) === null || _this$fetch$meta === void 0 ? void 0 : _this$fetch$meta.getRequestedMonths) === 'function') {
        // fetch function offers additional reasoning capabilities to
        // prevent unnecessary requests
        var requestedMonths = this.fetch.meta.getRequestedMonths(this.month);
        return requestedMonths;
      }
      return [this.month];
    }
  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this = this;
        var self, isFirstCallback, fallbackId, months, reqId;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              self = this;
              isFirstCallback = true;
              fallbackId = null;
              if (typeof this.fetchFallback === 'function') {
                fallbackId = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  var months;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return self.fetchFallback(self.month);
                      case 3:
                        months = _context.sent;
                        // if we received already data in the other request and did not cancel this timer in time,
                        // we are not interest in its result
                        if (isFirstCallback) {
                          months.forEach(function (monthObj) {
                            self.onFetched(_objectSpread2(_objectSpread2({
                              isFirstCallback: isFirstCallback
                            }, monthObj), {}, {
                              status: CALENDAR_MONTH_STATUS.PLACEHOLDER
                            }));
                          });
                          isFirstCallback = false;
                        }
                        _context.next = 10;
                        break;
                      case 7:
                        _context.prev = 7;
                        _context.t0 = _context["catch"](0);
                        /* Are we interested in errors? */
                        console.log(_context.t0);
                      case 10:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[0, 7]]);
                })), this.timeUntilFallback);
              }
              _context2.prev = 4;
              this.isExecuting = true;
              _context2.next = 8;
              return this.fetch(this.month);
            case 8:
              months = _context2.sent;
              reqId = this.id;
              months.forEach(function (monthObj) {
                _this.onFetched(_objectSpread2(_objectSpread2({
                  isFirstCallback: isFirstCallback
                }, monthObj), {}, {
                  status: CALENDAR_MONTH_STATUS.PRESENT,
                  reqId: reqId
                }));
              });
              clearTimeout(fallbackId);
              isFirstCallback = false;
              this.isExecuting = false;
              _context2.next = 20;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](4);
              /* Are we interested in errors? */
              console.log(_context2.t0);
              this.isExecuting = false;
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 16]]);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
}();
var RequestStackRepository = /*#__PURE__*/function () {
  function RequestStackRepository(_ref3) {
    var fetch = _ref3.fetch,
      fetchFallback = _ref3.fetchFallback,
      _ref3$maxSize = _ref3.maxSize,
      maxSize = _ref3$maxSize === void 0 ? 6 : _ref3$maxSize;
    _classCallCheck(this, RequestStackRepository);
    this.maxSize = maxSize;
    this.stack = [];
    this.fetch = fetch;
    this.fetchFallback = fetchFallback;
  }
  return _createClass(RequestStackRepository, [{
    key: "isMonthRequested",
    value: function isMonthRequested(month) {
      return this.stack.some(function (request) {
        return request.getRequestedMonths().includes(month);
      });
    }
  }, {
    key: "requestMonth",
    value: function requestMonth(requestedMonth, handleFetchResult) {
      var self = this;
      if (this.isMonthRequested(requestedMonth)) {
        return;
      }
      var onFetched = function onFetched(_ref4) {
        var isFirstCallback = _ref4.isFirstCallback,
          status = _ref4.status,
          month = _ref4.month,
          days = _ref4.days,
          reqId = _ref4.reqId;
        if (reqId) {
          self.removeStackEntry(reqId);
        }
        if (isFirstCallback) {
          self.executeNext();
        }
        handleFetchResult({
          status: status,
          month: month,
          days: days
        });
      };
      var request = new StackableRequest({
        month: requestedMonth,
        onFetched: onFetched,
        fetch: this.fetch,
        fetchFallback: this.fetchFallback
      });
      var isRequestRunning = this.stack.some(function (request) {
        return request.isExecuting;
      });
      if (!isRequestRunning) {
        request.execute();
      }
      this.stack.push(request);

      // TODO: evaluate if we should re-order the stack to prioritize requests closer to the requested month
      while (this.stack.length > this.maxSize) {
        this.stack.shift();
      }
    }
  }, {
    key: "removeStackEntry",
    value: function removeStackEntry(reqId) {
      this.stack = this.stack.filter(function (request) {
        return request.id !== reqId;
      });
    }
  }, {
    key: "executeNext",
    value: function executeNext() {
      if (this.stack.length > 0) {
        var request = this.stack.pop();
        request.execute();
      }
    }
  }]);
}();

var storage = new Map();
var SessionStorageRepository = /*#__PURE__*/function () {
  function SessionStorageRepository(id) {
    _classCallCheck(this, SessionStorageRepository);
    this.id = id;
  }
  return _createClass(SessionStorageRepository, [{
    key: "getMonth",
    value: function getMonth(month) {
      var key = "".concat(this.id, "-prices-calendar-month-").concat(month);
      var entry = storage.has(key) ? storage.get(key) : null;
      if (entry) {
        try {
          return JSON.parse(entry);
        } catch (e) {
          /* Ignore */
        }
      }
      return null;
    }
  }, {
    key: "setMonth",
    value: function setMonth(month, monthData) {
      try {
        var serializedData = JSON.stringify(monthData);
        var key = "".concat(this.id, "-prices-calendar-month-").concat(month);
        storage.set(key, serializedData);
        return monthData;
      } catch (e) {
        return null;
      }
    }
  }]);
}();

var getId = function getId() {
  var id_counter = 0;
  return function () {
    return ++id_counter;
  };
};
var SingletonRepository = /*#__PURE__*/function () {
  function SingletonRepository() {
    _classCallCheck(this, SingletonRepository);
    this.repos = new Map();
  }
  return _createClass(SingletonRepository, [{
    key: "getOrCreateRepository",
    value: function getOrCreateRepository(repoId, fetch, fetchFallback) {
      if (this.repos.has(repoId)) {
        return this.repos.get(repoId);
      }
      var sessionStorage = new SessionStorageRepository(repoId);
      var requestRepository = new RequestStackRepository({
        fetch: fetch,
        fetchFallback: fetchFallback
      });
      var repos = [sessionStorage, requestRepository];
      this.repos.set(repoId, repos);
      return repos;
    }
  }]);
}();
var REPOS = new SingletonRepository();
var CalendarMonthRepository = /*#__PURE__*/function () {
  function CalendarMonthRepository(_ref) {
    var repoId = _ref.repoId,
      fetch = _ref.fetch,
      fetchFallback = _ref.fetchFallback;
    _classCallCheck(this, CalendarMonthRepository);
    this.subscriptions = [];
    this.fetch = fetch;
    this.fetchFallback = fetchFallback;
    this.triggerCalendarMonthEventTimerId = null;
    var _REPOS$getOrCreateRep = REPOS.getOrCreateRepository(repoId, fetch, fetchFallback),
      _REPOS$getOrCreateRep2 = _slicedToArray(_REPOS$getOrCreateRep, 2),
      sessionStorage = _REPOS$getOrCreateRep2[0],
      requestRepository = _REPOS$getOrCreateRep2[1];
    this.sessionStorage = sessionStorage;
    this.requestRepository = requestRepository;
  }
  return _createClass(CalendarMonthRepository, [{
    key: "getMonth",
    value: function getMonth(month) {
      var monthObj = this.sessionStorage.getMonth(month);
      if (!monthObj) {
        monthObj = this.generatePlaceholderMonth(month);
      }
      var isFetchRequired = monthObj.status !== CALENDAR_MONTH_STATUS.PRESENT;
      this.sessionStorage.setMonth(month, monthObj);
      if (isFetchRequired) {
        this.fetchMonthData(month);
      }
      return monthObj;
    }
  }, {
    key: "generatePlaceholderMonth",
    value: function generatePlaceholderMonth(month) {
      var startDate = new Date(Date.parse(month));
      var endDate = new Date(Date.parse(month));
      endDate.setMonth(endDate.getMonth() + 1);
      var numOfDays = Math.floor((endDate - startDate) / 24 / 60 / 60 / 1000);
      var days = [];
      var isInDummyMode = typeof this.fetch !== 'function';
      var status = isInDummyMode ? CALENDAR_MONTH_STATUS.PRESENT : CALENDAR_MONTH_STATUS.PLACEHOLDER;
      for (var i = 0; i < numOfDays; i++) {
        var dateObj = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + i);
        var date = formatToIsoDateString(dateObj);
        days.push({
          date: date,
          status: status,
          loading: !isInDummyMode,
          available: true
        });
      }
      return {
        month: month,
        days: days,
        status: CALENDAR_MONTH_STATUS.PLACEHOLDER
      };
    }
  }, {
    key: "fetchMonthData",
    value: function fetchMonthData(month) {
      var isInDummyMode = typeof this.fetch !== 'function';
      if (isInDummyMode) {
        return;
      }
      var self = this;
      // this callback might be triggered in rappid succession for a few times,
      // depending on how many months the fetch functionality returns
      this.requestRepository.requestMonth(month, function (monthdata) {
        self.sessionStorage.setMonth(monthdata.month, monthdata);
        self.triggerCalendarMonthEvent();
      });
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(callback) {
      callback.callbackId = getId();
      this.subscriptions.push(callback);
      return callback.callbackId;
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(callbackId) {
      this.subscriptions = this.subscriptions.filter(function (callback) {
        return callback.callbackId !== callbackId;
      });
    }
  }, {
    key: "triggerCalendarMonthEvent",
    value: function triggerCalendarMonthEvent() {
      var self = this;
      clearTimeout(this.triggerCalendarMonthEventTimerId);
      this.triggerCalendarMonthEventTimerId = setTimeout(function () {
        self.subscriptions.forEach(function (callback) {
          return callback();
        });
      }, 10);
    }
  }]);
}();

var _excluded$3 = ["repoIdentifier", "fetch", "fetchFallback", "showPrice", "onPrevMonthClick", "onNextMonthClick", "initialStartDate", "onCalendarOpenClose", "onChange", "isVisible", "maxPossibleStayDays"];
var getRepoId$1 = function () {
  var id = 0;
  return function () {
    var randomToken = Math.random().toString(36);
    return "repo_".concat(randomToken, "_").concat(++id);
  };
}();
var WithPriceDataFactory = function WithPriceDataFactory() {
  var repoRegistry = {};
  var getStartOfCalendar = function getStartOfCalendar(month) {
    if (month) {
      return moment(month.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('month');
    }
    return moment().startOf('month');
  };
  var extendObjWithDay = function extendObjWithDay(obj) {
    var day = moment(obj.date, 'YYYY-MM-DD');
    return _objectSpread2(_objectSpread2({}, obj), {}, {
      day: day
    });
  };
  return function (CalendarComponent) {
    function WithPriceCalendarComponent(_ref) {
      var repoIdentifier = _ref.repoIdentifier,
        fetch = _ref.fetch,
        fetchFallback = _ref.fetchFallback,
        showPrice = _ref.showPrice,
        onPrevMonthClick = _ref.onPrevMonthClick,
        onNextMonthClick = _ref.onNextMonthClick,
        initialStartDate = _ref.initialStartDate,
        onCalendarOpenClose = _ref.onCalendarOpenClose,
        onChange = _ref.onChange,
        isVisible = _ref.isVisible,
        maxPossibleStayDays = _ref.maxPossibleStayDays,
        props = _objectWithoutProperties(_ref, _excluded$3);
      var _useState = useState(repoIdentifier || getRepoId$1()),
        _useState2 = _slicedToArray(_useState, 2),
        repoId = _useState2[0],
        setRepoId = _useState2[1];
      var callbackId = useRef(null);
      var repo = useRef(null);
      var visibleMonths = useRef([]);
      var calendarStart = useRef(getStartOfCalendar(initialStartDate));
      var windowSize = useWindowSize();
      var _useState3 = useState([]),
        _useState4 = _slicedToArray(_useState3, 2),
        prices = _useState4[0],
        setPrices = _useState4[1];
      var _useState5 = useState([]),
        _useState6 = _slicedToArray(_useState5, 2),
        notAvailableDates = _useState6[0],
        setNotAvailableDates = _useState6[1];
      var numOfMonths = useMemo(function () {
        var isMobile = windowSize.width <= 768 && !showPrice;
        var showOneMonthPrice = showPrice && windowSize.width <= 768;
        if (showOneMonthPrice) {
          return 1;
        }
        if (isMobile) {
          return 6;
        }
        return 2;
      }, [windowSize, showPrice]);
      var onMonthDataChanged = useCallback(function () {
        if (!repo.current) {
          return;
        }
        var nonAvDates = [];
        var nextVisiblePrices = [];
        visibleMonths.current.forEach(function (monthDate) {
          var month = repo.current.getMonth(monthDate);
          nextVisiblePrices.push.apply(nextVisiblePrices, _toConsumableArray(month.days.map(function (day) {
            return extendObjWithDay(day);
          })));
        });
        groupDatesInRanges(nextVisiblePrices.filter(function (day) {
          return typeof day.available !== 'undefined' && !day.available;
        }).map(function (day) {
          return day.day.toDate();
        })).forEach(function (range) {
          nonAvDates.push({
            from: moment(range.from),
            to: moment(range.to)
          });
        });
        setPrices(nextVisiblePrices);
        setNotAvailableDates(nonAvDates);
      }, [visibleMonths]);
      var updateVisibleMonths = useCallback(function (currentMonth) {
        var months = [];
        for (var i = 0; i < numOfMonths; i++) {
          months.push(currentMonth.clone().startOf('month').add(i, 'month').format('YYYY-MM-DD'));
        }
        visibleMonths.current = months;
      }, [numOfMonths]);
      var onDateSelectionChange = useCallback(function (_ref2) {
        var startDate = _ref2.startDate,
          endDate = _ref2.endDate,
          fromAction = _ref2.fromAction;
        if (!!startDate) {
          calendarStart.current = getStartOfCalendar(startDate);
        }
        if (typeof onChange === 'function') {
          onChange({
            startDate: startDate,
            endDate: endDate,
            fromAction: fromAction
          });
        }
      }, [onChange]);
      var handlePrevMonthClick = useCallback(function (currentMonth) {
        updateVisibleMonths(currentMonth);
        setTimeout(function () {
          onMonthDataChanged();
        }, 0);
        if (typeof onPrevMonthClick === 'function') {
          onPrevMonthClick(currentMonth);
        }
      }, [onPrevMonthClick, updateVisibleMonths]);
      var handleNextMonthClick = useCallback(function (currentMonth) {
        updateVisibleMonths(currentMonth);
        setTimeout(function () {
          onMonthDataChanged();
        }, 0);
        if (typeof onNextMonthClick === 'function') {
          onNextMonthClick(currentMonth);
        }
      }, [onNextMonthClick, updateVisibleMonths]);
      var onOpenCloseChange = useCallback(function (isOpen) {
        if (isOpen) {
          onMonthDataChanged();
        } else {
          updateVisibleMonths(calendarStart.current);
        }
        if (typeof onCalendarOpenClose === 'function') {
          onCalendarOpenClose(isOpen);
        }
      }, [onMonthDataChanged, onCalendarOpenClose]);
      useEffect(function () {
        setRepoId(repoIdentifier);
      }, [repoIdentifier]);
      useEffect(function () {
        calendarStart.current = getStartOfCalendar(initialStartDate);
        updateVisibleMonths(calendarStart.current);
        onMonthDataChanged();
      }, [initialStartDate]);
      useEffect(function () {
        if (isVisible) {
          setTimeout(function () {
            onMonthDataChanged();
          }, 0);
        }
      }, [isVisible]);

      // You may look at this and go: ಠ_ಠ "that looks wrong"
      // But that's what Meta wants us to do. "it reduces bugs" - so we register/deregister
      // callbacks on each render cycle.
      // https://legacy.reactjs.org/docs/hooks-effect.html#explanation-why-effects-run-on-each-update
      useEffect(function () {
        repo.current = repoRegistry[repoId];
        if (!repo.current) {
          repo.current = new CalendarMonthRepository({
            repoId: repoId,
            fetch: fetch,
            fetchFallback: fetchFallback
          });
          repoRegistry[repoId] = repo.current;

          // if we need to define the repo, we need to fetch the data for the initial filling.
          // but this should hapen after registering the event handler -> therefore
          // moving call to after this function call
          setTimeout(function () {
            return onMonthDataChanged();
          }, 0);
        }
        callbackId.current = repo.current.addEventListener(function () {
          onMonthDataChanged();
        });
        return function () {
          repo.current.removeEventListener(callbackId.current);
        };
      });
      return /*#__PURE__*/React__default.createElement(CalendarComponent, _extends({
        showPrice: showPrice,
        onNextMonthClick: handleNextMonthClick,
        onPrevMonthClick: handlePrevMonthClick,
        dayPrices: prices,
        notAvailableDates: notAvailableDates,
        showInputs: true,
        onCalendarOpenClose: onOpenCloseChange,
        onChange: onDateSelectionChange,
        maxPossibleStayDays: maxPossibleStayDays
      }, props));
    }
    WithPriceCalendarComponent.propTypes = {
      repoIdentifier: PropTypes.string,
      fetch: PropTypes.func,
      fetchFallback: PropTypes.func,
      showPrice: PropTypes.bool,
      onPrevMonthClick: PropTypes.func,
      onNextMonthClick: PropTypes.func,
      initialStartDate: src.momentObj,
      onCalendarOpenClose: PropTypes.func,
      onChange: PropTypes.func,
      isVisible: PropTypes.bool,
      maxPossibleStayDays: PropTypes.number
    };
    WithPriceCalendarComponent.defaultProps = {
      repoIdentifier: null,
      fetch: null,
      fetchFallback: null,
      showPrice: true,
      onPrevMonthClick: function onPrevMonthClick() {},
      onNextMonthClick: function onNextMonthClick() {},
      initialStartDate: null,
      onCalendarOpenClose: function onCalendarOpenClose() {},
      onChange: function onChange() {},
      isVisible: true,
      maxPossibleStayDays: 14
    };
    return WithPriceCalendarComponent;
  };
};
var withPriceData = WithPriceDataFactory();

var _excluded$2 = ["repoIdentifier", "fetch", "fetchFallback", "showPrice", "onPrevMonthClick", "onNextMonthClick", "initialStartDate", "onCalendarOpenClose"];
var getRepoId = function () {
  var id = 0;
  return function () {
    var randoToken = Math.random().toString(36);
    return "repo_".concat(randoToken, "_").concat(++id);
  };
}();
var WithAvailabilityDataFactory = function WithAvailabilityDataFactory() {
  var repoRegistry = {};
  var getStartOfCalendar = function getStartOfCalendar(month) {
    if (month) {
      return moment(month.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('month');
    }
    return moment().startOf('month');
  };
  var extendObjWithDay = function extendObjWithDay(obj) {
    var day = moment(obj.date, 'YYYY-MM-DD');
    return _objectSpread2(_objectSpread2({}, obj), {}, {
      day: day
    });
  };
  return function (CalendarComponent) {
    function WithAvailabilityCalendarComponent(_ref) {
      var repoIdentifier = _ref.repoIdentifier,
        fetch = _ref.fetch,
        fetchFallback = _ref.fetchFallback,
        showPrice = _ref.showPrice,
        onPrevMonthClick = _ref.onPrevMonthClick,
        onNextMonthClick = _ref.onNextMonthClick,
        initialStartDate = _ref.initialStartDate,
        onCalendarOpenClose = _ref.onCalendarOpenClose,
        props = _objectWithoutProperties(_ref, _excluded$2);
      var _useState = useState(repoIdentifier || getRepoId()),
        _useState2 = _slicedToArray(_useState, 2),
        repoId = _useState2[0],
        setRepoId = _useState2[1];
      var callbackId = useRef(null);
      var repo = useRef(null);
      var visibleMonths = useRef([]);
      var calendarStart = useRef(getStartOfCalendar(initialStartDate));
      var dateStates = useRef([]);
      var windowSize = useWindowSize();
      var isMobile = windowSize.width <= 768 && !showPrice;
      var showOneMonthPrice = showPrice && windowSize.width <= 768;
      var numOfMonths = useRef(isMobile ? 6 : 2);
      var _useState3 = useState([]),
        _useState4 = _slicedToArray(_useState3, 2),
        notAvailableDates = _useState4[0],
        setNoAvailableDates = _useState4[1];
      numOfMonths.current = showOneMonthPrice ? 1 : numOfMonths.current;
      var updateVisibleMonths = useCallback(function (currentMonth) {
        var months = [];
        for (var i = 0; i < numOfMonths.current; i++) {
          months.push(currentMonth.clone().startOf('month').add(i, 'month').format('YYYY-MM-DD'));
        }
        visibleMonths.current = months;
      }, [numOfMonths]);
      var handlePrevMonthClick = useCallback(function (currentMonth) {
        updateVisibleMonths(currentMonth);
        onMonthDataChanged();
        if (typeof onPrevMonthClick === 'function') {
          onPrevMonthClick(currentMonth);
        }
      }, [onPrevMonthClick, updateVisibleMonths]);
      var handleNextMonthClick = useCallback(function (currentMonth) {
        updateVisibleMonths(currentMonth);
        onMonthDataChanged();
        if (typeof onNextMonthClick === 'function') {
          onNextMonthClick(currentMonth);
        }
      }, [onNextMonthClick, updateVisibleMonths]);
      var onMonthDataChanged = useCallback(function () {
        if (!repo.current) {
          return;
        }
        dateStates.current = [];
        var nonAvDates = [];
        visibleMonths.current.forEach(function (monthDate) {
          var month = repo.current.getMonth(monthDate);
          dateStates.current.push(month.status);
          groupDatesInRanges(month.days.filter(function (day) {
            return typeof day.available !== 'undefined' && !day.available;
          }).map(function (day) {
            return extendObjWithDay(day);
          }).map(function (day) {
            return day.day.toDate();
          })).forEach(function (range) {
            nonAvDates.push({
              from: moment(range.from),
              to: moment(range.to)
            });
          });
        });
        setNoAvailableDates(nonAvDates);
      }, [visibleMonths]);
      var onOpenCloseChange = useCallback(function (isOpen) {
        if (isOpen) {
          onMonthDataChanged();
        }
        if (typeof onCalendarOpenClose === 'function') {
          onCalendarOpenClose(isOpen);
        }
      }, [onMonthDataChanged, onCalendarOpenClose]);
      useEffect(function () {
        setRepoId(repoIdentifier);
      }, [repoIdentifier]);
      useEffect(function () {
        onMonthDataChanged();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [visibleMonths.current]);
      useEffect(function () {
        calendarStart.current = getStartOfCalendar(initialStartDate);
        updateVisibleMonths(calendarStart.current);
      }, [initialStartDate, updateVisibleMonths]);
      useEffect(function () {
        repo.current = repoRegistry[repoId];
        if (!repo.current) {
          repo.current = new CalendarMonthRepository({
            repoId: repoId,
            fetch: fetch,
            fetchFallback: fetchFallback
          });
          repoRegistry[repoId] = repo.current;

          // if we need to define the repo, we need to fetch the data for the initial filling.
          // but this should hapen after registering the event handler -> therefore
          // moving call to after this function call
          setTimeout(function () {
            return onMonthDataChanged();
          }, 0);
        }
        callbackId.current = repo.current.addEventListener(function () {
          onMonthDataChanged();
          log('onMonthDataChanged called from repo event');
        });
        return function () {
          repo.current.removeEventListener(callbackId.current);
        };
      });
      useEffect(function () {
        if (repo.current) {
          repo.current.removeEventListener(callbackId);
        }
      }, []);
      return /*#__PURE__*/React__default.createElement(CalendarComponent, _extends({
        showPrice: showPrice,
        onNextMonthClick: handleNextMonthClick,
        onPrevMonthClick: handlePrevMonthClick,
        notAvailableDates: notAvailableDates,
        showInputs: true,
        maxPossibleStayDays: 21,
        onCalendarOpenClose: onOpenCloseChange
      }, props));
    }
    WithAvailabilityCalendarComponent.propTypes = {
      repoIdentifier: PropTypes.string,
      fetch: PropTypes.func,
      fetchFallback: PropTypes.func,
      showPrice: PropTypes.bool,
      onPrevMonthClick: PropTypes.func,
      onNextMonthClick: PropTypes.func,
      initialStartDate: src.momentObj,
      onCalendarOpenClose: PropTypes.func
    };
    WithAvailabilityCalendarComponent.defaultProps = {
      repoIdentifier: null,
      fetch: null,
      fetchFallback: null,
      showPrice: false,
      onPrevMonthClick: function onPrevMonthClick() {},
      onNextMonthClick: function onNextMonthClick() {},
      initialStartDate: null,
      onCalendarOpenClose: function onCalendarOpenClose() {}
    };
    return WithAvailabilityCalendarComponent;
  };
};
var withAvailabilityData = WithAvailabilityDataFactory();

var _excluded$1 = ["url", "occupancy", "globalMinOccupancy"];
var countPeopleInOccupancy = function countPeopleInOccupancy(occupancy) {
  var _ref = typeof occupancy === 'string' ? occupancy.split(':') : "".concat(occupancy).split(':'),
    _ref2 = _toArray(_ref),
    adults = _ref2[0],
    children = _ref2.slice(1); // we've got a numeric
  var sum = 0;
  sum += parseInt(adults, 10);
  children.forEach(function (_) {
    return sum++;
  });
  return sum;
};
var pickAvailabilityIdx = function pickAvailabilityIdx(numOfPeople, minOcc) {
  return numOfPeople - minOcc;
};
var pickAvailabilities = function pickAvailabilities(resp, occupancy, minOcc) {
  var numOfPeople = countPeopleInOccupancy(occupancy);
  var idx = pickAvailabilityIdx(numOfPeople, minOcc);
  return resp.availabilities[idx];
};
var transformAvailability = function transformAvailability(startDate, idx, binaryAvValue) {
  var dateOfIdxObj = new Date(Date.parse(startDate));
  dateOfIdxObj.setDate(dateOfIdxObj.getDate() + idx);
  var dateOfIdx = formatToIsoDateString(dateOfIdxObj);
  return {
    date: dateOfIdx,
    status: CALENDAR_MONTH_STATUS.PRESENT,
    loading: false,
    price: null,
    available: binaryAvValue === '1'
  };
};
var transformAvailabilities = function transformAvailabilities(resp, startDate, occupancy, globalMinOccupancy) {
  var availabilities = pickAvailabilities(resp, occupancy, globalMinOccupancy);
  var dateObjects = availabilities.split('').map(function (binaryAvValue, idx) {
    return transformAvailability(startDate, idx, binaryAvValue);
  });
  var monthObjects = [];
  var _loop = function _loop() {
    var dateObj = dateObjects[i];
    var startOfMonth = parseIsoDateString(dateObj.date);
    startOfMonth.setDate(1);
    var startOfMonthToken = formatToIsoDateString(startOfMonth);
    var monthObj = monthObjects.find(function (month) {
      return month.month === startOfMonthToken;
    });
    var isFirstOfNewMonth = !monthObj;
    if (isFirstOfNewMonth) {
      monthObjects.push({
        month: startOfMonthToken,
        days: [dateObj]
      });
    } else {
      monthObj.days.push(dateObj);
    }
  };
  for (var i = 0; i < dateObjects.length; i++) {
    _loop();
  }
  return monthObjects;
};

/**
 * Returns a function that fetches availabilities from the availabilities endpoint
 *
 * @param {} url url to the availabilites endpoint
 * @returns a list of availabilities in calendar format
 */
var getAvailabilityFetcher = function getAvailabilityFetcher(_ref3) {
  var url = _ref3.url,
    occupancy = _ref3.occupancy,
    globalMinOccupancy = _ref3.globalMinOccupancy,
    params = _objectWithoutProperties(_ref3, _excluded$1);
  function fetchAvailability(startDate) {
    var startDateObj = parseIsoDateString(startDate);
    var endDateObj = parseIsoDateString(startDate);
    endDateObj.setFullYear(startDateObj.getFullYear() + 1);
    endDateObj.setDate(endDateObj.getDate() - 1);
    var numberOfDays = calculateNumOfDays(endDateObj, startDateObj) - 1;
    var urlParams = _objectSpread2(_objectSpread2({}, params), {}, {
      numberOfDays: numberOfDays,
      occupancy: countPeopleInOccupancy(occupancy),
      startDate: formatToIsoDateString(startDateObj),
      lastDate: formatToIsoDateString(endDateObj)
    });
    var queryString = '?' + Object.keys(urlParams).map(function (key) {
      return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(urlParams[key]));
    }).join('&');
    var urlWithParams = url + queryString;
    return fetch(urlWithParams, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (resp) {
      return resp.json();
    }).then(function (resp) {
      return resp.result;
    }).then(function (resp) {
      return transformAvailabilities(resp, startDate, occupancy, globalMinOccupancy);
    });
  }
  fetchAvailability.meta = {
    getRequestedMonths: function getRequestedMonths(startDate) {
      var months = [];
      var dateObj = parseIsoDateString(startDate);
      for (var i = 0; i < 12; i++) {
        months.push(formatToIsoDateString(dateObj));
        dateObj.setMonth(dateObj.getMonth() + 1);
      }
      return months;
    }
  };
  return fetchAvailability;
};

var _excluded = ["url", "occupancy", "currencyCode", "isRoundingUp"];
var roundUp = function roundUp(num) {
  return typeof num === 'string' ? Math.ceil(parseFloat(num)) : Math.ceil(num);
};
var getCalendarPrices = function getCalendarPrices(_ref) {
  var url = _ref.url,
    occupancy = _ref.occupancy,
    currencyCode = _ref.currencyCode,
    _ref$isRoundingUp = _ref.isRoundingUp,
    isRoundingUp = _ref$isRoundingUp === void 0 ? true : _ref$isRoundingUp,
    params = _objectWithoutProperties(_ref, _excluded);
  return function (startDate) {
    var firstDate = startDate;
    var lastDate = getLastDateParameterForCalendar(startDate);
    var paramsForUrl = _objectSpread2(_objectSpread2({}, params), {}, {
      occupancy: occupancy,
      lastDate: lastDate,
      firstDate: firstDate
    });
    if (currencyCode) {
      paramsForUrl.currencyCode = currencyCode;
      if (!paramsForUrl.targetCurrency) {
        paramsForUrl.targetCurrency = currencyCode;
      }
    }
    var queryString = '?' + Object.keys(paramsForUrl).map(function (key) {
      return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(paramsForUrl[key]));
    }).join('&');
    var urlWithParams = url + queryString;
    return fetch(urlWithParams, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (resp) {
      return resp.json();
    }).then(function (resp) {
      return resp.result;
    }).then(function (days) {
      return (days || []).map(function (day) {
        var _day$possibleStays, _day$possibleStays2;
        day.currencyCode = currencyCode;
        day.day = moment(day.date, 'YYYY-MM-DD');
        day.available = typeof day.price === 'number';
        var minLengthOfStay = (_day$possibleStays = day.possibleStays) === null || _day$possibleStays === void 0 ? void 0 : _day$possibleStays[0];
        var maxLengthOfStay = (_day$possibleStays2 = day.possibleStays) === null || _day$possibleStays2 === void 0 ? void 0 : _day$possibleStays2[day.possibleStays.length - 1];
        day.minLengthOfStay = minLengthOfStay;
        day.maxLengthOfStay = maxLengthOfStay;
        if (isRoundingUp) {
          day.price = roundUp(day.price);
        }
        return day;
      });
    }).then(function (days) {
      return [{
        days: days,
        month: startDate
      }];
    });
  };
};

var createOccupancyParameters = function createOccupancyParameters() {
  var occupancy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!(occupancy === null || occupancy === void 0 ? void 0 : occupancy.length)) {
    return '';
  }
  return occupancy.flatMap(function (occupancyData, roomIndex) {
    var _occupancyData$childr;
    var adults = occupancyData.adults;
    var params = [];
    if (adults) {
      params.push("adult_room".concat(roomIndex + 1, "=").concat(adults));
    }
    if (((_occupancyData$childr = occupancyData.children) === null || _occupancyData$childr === void 0 ? void 0 : _occupancyData$childr.length) > 0) {
      var childrenOccupancyCounts = occupancyData.children.reduce(function (counts, age) {
        counts[age] = (counts[age] || 0) + 1;
        return counts;
      }, {});
      params.push.apply(params, _toConsumableArray(Object.entries(childrenOccupancyCounts).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          age = _ref2[0],
          count = _ref2[1];
        return "child_room".concat(roomIndex + 1, "_age").concat(age, "=").concat(count);
      })));
    }
    return params;
  }).join('&');
};

export { createOccupancyParameters, getAvailabilityFetcher, getCalendarPrices, withAvailabilityData, withPriceData };
